import React, { useEffect, useState, useRef, useContext } from 'react';
import { Button, Select, Table, DatePicker, Form, Row, Col, Input } from 'antd';
import http from '../Http';
import utils from '../utils';
import config from '../Config';
import { CloudDownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';


function getTableScroll() {
    var th = document.getElementsByClassName("ant-table-thead")[0];
    let tHeaderBottom = 0
    if (th) {
        tHeaderBottom = th.getBoundingClientRect().top
    }
    let height = `calc(100vh - ${tHeaderBottom + 100}px)`
    return height
}

function DryContactDataExporter(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext)

    const [pageNo, setPageNo] = useState(0)
    const [pageSize, setPageSize] = useState(100)
    const [rows, setRows] = useState([])
    const [rowTotal, setRowTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [deviceSelectOptions, setDeviceSelectOptions] = useState([]);

    const [STime, setSTime] = useState(moment());
    const [ETime, setETime] = useState(moment().add(1, "days"));
    const [SN, setSN] = useState("")
    const [next, setNext] = useState(0)
    const [dates, setDates] = useState(null)
    const [range, setRange] = useState(null)

    const refTimerDeviceSearcher = useRef(null);
    const refDeviceSearchValue = useRef(null);
    const refDownloader = useRef(null)

    const [scrollY, setScrollY] = useState("")

    const [form] = Form.useForm();

    useEffect(() => {
        setScrollY(getTableScroll())
    }, [])


    const dateTimeFormat = new Intl.DateTimeFormat();
    const timeZone = dateTimeFormat.resolvedOptions().timeZone;
    const timeZoneOffset = -new Date().getTimezoneOffset()*60;


    const handleSearchDevice = (v) => {
        if (refTimerDeviceSearcher.current != null) {
            clearTimeout(refTimerDeviceSearcher.current);
        }
        refDeviceSearchValue.current = v;

        const id = form.getFieldValue("DeviceID");

        refTimerDeviceSearcher.current = setTimeout(async () => {
            const resp = await http.post("device/id-name/list", {
                DistributorIsTheSameAsTheDeviceID: id || "",
                SN: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DryContactDataExporter]", e);
                return null;
            });

            if (refDeviceSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_device_list_error") });
                    return;
                }

                const ls = resp.data.map(({ SN, ID }) => {
                    return (
                        <Select.Option key={SN} value={SN}>{SN}</Select.Option>
                    );
                });
                setDeviceSelectOptions(ls);
            } catch (e) {
                console.log("[DryContactDataExporter]", e);

                setTip({ open: true, severity: "error", msg: t("load_device_list_error") });
            }
        }, 300);
    }


    //取历史数据
    useEffect(() => {
        if (!SN) return;

        let active = true;

        (async () => {
            setLoading(true);

            let resp = await http.post("dry-contact/history/list", {
                PageNo: pageNo,
                PageSize: pageSize,
                SerialNumber: SN,
                STime: STime.format("YYYY-MM-DD"),
                ETime: ETime.format("YYYY-MM-DD"),
                TimezoneOffset: timeZoneOffset,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load data error") });
                setRowTotal(0)
                setRows([])
                return;
            }

            //console.log('drycontact: ', resp.data);

            resp.data.Rows = resp.data.Rows.map(item => {
                //handle data
                let data = item.Data;
                if(data){
                    if(data.length < 16) { //小于16个字符则补足16个
                        data = data.padEnd(16, '0');
                    } else if(data.length > 16) {  //大于16个字符则取前16个
                        data = data.slice(0, 16);
                    }
                    //将长度为16的hex字符串转换为64bit的串
                    const bits = data.split('').map(v => Number('0x' + v).toString(2).padStart(4, '0')).join('')  
                    //将64bit的串按字节分割为数组
                    const bytes = bits.match(/(.{8})/g);
                    //对bytes的每个字节进行处理
                    const vs = bytes.map(v => parseInt(v, 2))
                    const ValueNumber = vs[0]
                    const ValueAlarmLevel = vs[1]
                    const TempDetector = vs[2] == 0 ? t('Normal') : vs[2] == 1 ? t('Alarm') : t('Unknown')
                    const SmokeDetector = vs[3] == 0 ? t('Normal') : vs[3] == 1 ? t('Alarm') : t('Unknown')
                    const SpaceDetector = vs[4]
                    const AlarmSwitch = vs[5] == 0 ? t('Alarm-Switch-Up') : vs[5] == 1 ? t('Alarm-Switch-Down') : t('Unknown')
                    const MessageCounter = vs[6]
                    const v8 = bytes[7]  //第8个字节单独处理
                    const v8_1 = v8.slice(0, 2)
                    const v8_2 = v8.slice(2, 8)
                    const levelValue = parseInt(v8_1, 2)
                    const FaultLevel = levelValue == 0 ? t('None') : levelValue == 1 ? t('Level 1') : levelValue === 2 ? t('Level 2') : t('Unknown')
                    const FaultCode = parseInt(v8_2, 2)
                    
                    item = {
                        ...item,
                        ValueNumber,
                        ValueAlarmLevel,
                        TempDetector,
                        SmokeDetector,
                        SpaceDetector,
                        AlarmSwitch,
                        MessageCounter,
                        FaultLevel,
                        FaultCode
                    }
                }

                return item;
            })

            setRowTotal(resp.data.RowTotal);
            setRows(resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [pageNo, pageSize, SN, STime, ETime, next]);

    const handleExport = () => {
        if (!refDownloader.current) {
            return;
        }
        refDownloader.current.click()
    }

    const columns = [
        {
            title: "",
            width: 40,
            fixed: 'left',
            render: (v, r, idx) => {
                return (pageNo * pageSize + idx + 1);
            } 
        }, {
            title: t('Upload Time')+"("+timeZone+")",
            dataIndex: 'CreateTime',
            width: 200,
        }, {
            title: t('Device Type'),
            dataIndex: 'DeviceType',
            width: 90,
            render: (v) => {
                return v 
            }
        }, {
            title: t('Value Number'),
            dataIndex: 'ValueNumber',
            width: 110,
        }, {
            title: t('Value Alarm Level'),
            dataIndex: 'ValueAlarmLevel',
            width: 130,
        }, {
            title: t('Temperature Detector'),
            dataIndex: 'TempDetector',
            width: 155,
            transform: {
                map: {
                    0: t('Normal'),
                    1: t('Alarm'),
                    2: t('Unknown')
                }
            }
        }, {
            title: t('Smoke Detector'),
            dataIndex: 'SmokeDetector',
            width: 120,
            transform: {
                map: {
                    0: t('Normal'),
                    1: t('Alarm'),
                    2: t('Unknown')
                }
            }
        }, {
            title: t('Space Detector'),
            dataIndex: 'SpaceDetector',
            width: 120,
        }, {
            title: t('Alarm Switch'),
            dataIndex: 'AlarmSwitch',
            width: 120,
            transform: {
                map: {
                    0: t('Alarm-Switch-Up'),
                    1: t('Alarm-Switch-Down'),
                    2: t('Unknown')
                }
            }
        }, {
            title: t('Message Counter'),
            dataIndex: 'MessageCounter',
            width: 125,
        }, {
            title: t('Fault Level'),
            dataIndex: 'FaultLevel',
            width: 100,
            transform: {
                map: {
                    0: t('None'),
                    1: t('Level 1'),
                    2: t('Level 2'),
                    3: t('Unknown')
                }
            }
        }, {
            title: t('Fault Code'),
            dataIndex: 'FaultCode',
            width: 100,
            render: (v) => {
                const ms = {
                    1: t('1: Level 4 Warning'),
                    2: t('2: Level 3 Warning'), 
                    3: t('3: Level 2 Warning'),
                    4: t('4: Sensor Fault'),
                    5: t('5: Hardware Fault')
                }
                return v == 0 ? t('None') :(ms[parseInt(v)] ?? t('Unknown'))
            },
            transform: {
                map: {
                    0: t('None'),
                    1: t('1: Level 4 Warning'),
                    2: t('2: Level 3 Warning'), 
                    3: t('3: Level 2 Warning'),
                    4: t('4: Sensor Fault'),
                    5: t('5: Hardware Fault')
                }
            }
        }
    ];
    let strColumns = [];
    for (let i = 0; i < columns.length; i++) {
        const c = columns[i];
        if (c.dataIndex) {
            strColumns.push({
                title: c.title,
                dataIndex: c.dataIndex,
                transform: c.transform,
                width: c.width,
            });
        }
    }
    strColumns = encodeURIComponent(JSON.stringify(strColumns));

    return (
        <div style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            backgroundColor: '#EFF8FE',
            padding: 8,
        }}>
            <div style={{
                flex: "0 1 auto",
            }}>
                <Form
                    form={form}
                    initialValues={{
                        DateRange: [moment(), moment()]
                    }}
                    style={{
                        padding: 24,
                        background: '#fbfbfb',
                        border: '1px solid #d9d9d9',
                        borderRadius: 2
                    }}
                >
                    <Row gutter={24}>
                        <Col span={8} key="DeviceID">
                            <Input.Group compact>
                                <Button>{t("Device SN")}</Button>
                                <Form.Item
                                    name="DeviceID"
                                    label=""
                                    style={{display: 'inline-block', width: 'calc(100% - 120px)'}}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t("Device SN")}
                                        defaultActiveFirstOption={false}
                                        showArrow={false}
                                        filterOption={false}
                                        onSearch={(value) => {
                                            handleSearchDevice(value);
                                        }}
                                        onSelect={(value, option) => setSN(value)}
                                    >{deviceSelectOptions}</Select>
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={10} key="DateRange" >
                            <Form.Item
                                name="DateRange"
                                label=""
                            >
                                <DatePicker.RangePicker
                                    style={{ borderRadius: '20px'}}
                                    value={[STime, ETime]}
                                    disabledDate={(current) => {
                                        if(!dates) {
                                            return false;
                                        }
                                        if(range == 'start') {
                                            return current.diff(dates[0], 'days') > 7
                                        } else if(range == 'end') {
                                            return Math.abs(current.diff(dates[1], 'days')) > 7
                                        }
                                    }}
                                    onCalendarChange={(dates, dateStrings, info) => {
                                        setRange(info.range)
                                        setDates(dates)
                                    }}
                                    onOpenChange={(open) => {
                                        if(!open) {
                                            if (dates && dates.length > 1) {
                                                setSTime(dates[0])
                                                setETime(dates[1])
                                            }
                                            setRange(null)
                                            setDates(null)
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6} style={{ textAlign: 'right' }}>
                            <Button type="primary" shape="round" onClick={() => {setPageNo(0); setNext(next + 1)}}>
                                {t("Search")}
                            </Button>
                            <Button
                                shape="round"
                                style={{ margin: '0 8px' }}
                                onClick={() => {
                                    form.resetFields();
                                }}
                            >
                                {t("Clear")}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div style={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                paddingTop: 8,
                paddingBottom: 8,
            }}>
                <Button disabled={rows.length < 1 ? true : false} onClick={handleExport} type="primary" icon={<CloudDownloadOutlined />} size="middle" />
            </div>
            <div style={{
                flex: "1 1 1px",
                position: "relative",
            }}>
                <div style={{ position: "absolute", height: '100%', width: "100%", overflow: "hidden" }}>
                    <Table
                        columns={columns}
                        pagination={{
                            pageSizeOptions: [25, 50, 100],
                            current: pageNo + 1,
                            pageSize: pageSize,
                            total: rowTotal,
                            showSizeChanger: true,
                            showTotal: (total) => { return t('Total {{total}}', { total }) },
                            onShowSizeChange: (current, size) => {
                                setPageSize(size);
                            },
                            onChange: (page, pageSize) => {
                                setPageNo(page - 1);
                            }
                        }}
                        tableLayout="fixed"
                        bordered={true}
                        size="small"
                        loading={loading}
                        rowKey="ID"
                        dataSource={rows}
                        scroll={{ x: 'max-content', y: scrollY }}
                    >
                    </Table>
                </div>
            </div>

            <a ref={refDownloader} style={{ display: "none" }} href={config.apiUrl + "data-export/drycontact/history/do?Token=" + http.token + "&SerialNumber=" + SN + "&STime=" + STime.format("YYYY-MM-DD") + "&ETime=" + ETime.format("YYYY-MM-DD") + "&TimezoneOffset=" + timeZoneOffset + "&Columns=" + strColumns}></a>
        </div>
    )
}

export default DryContactDataExporter;